import React from 'react';

import { useIntl } from 'react-intl-next';

import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';

import type { AIPlugin } from '../../../aiPluginType';
import { createOpenAIModalCommand } from '../../../pm-plugins/decoration/actions';
import type { EditorPluginAIProvider } from '../../../types/types';
import type { BlockMenuActionDef } from '../types';

export const BlockMenuActionItem = ({
	action,
	api,
	editorPluginAIProvider,
	getEditorView,
}: {
	action: BlockMenuActionDef;
	api: ExtractInjectionAPI<AIPlugin>;
	editorPluginAIProvider: EditorPluginAIProvider;
	getEditorView: () => EditorView | undefined;
}): React.JSX.Element => {
	const { formatMessage, locale } = useIntl();

	return (
		<ToolbarDropdownItem
			elemBefore={action.elemBefore}
			onClick={() => {
				const editorView = getEditorView();
				if (!editorView) {
					return;
				}

				const openAIModalCommand = createOpenAIModalCommand({
					state: editorView.state,
					configItem: action.configItem,
					lastTriggeredFrom: 'blockMenu',
					triggerMethod: 'click',
					aiGlobalOptIn: editorPluginAIProvider.aiGlobalOptIn,
					locale,
				});

				openAIModalCommand(editorView.state, editorView.dispatch);

				// Close the block menu (defensive - block controls are optional)
				api?.core?.actions.execute(
					api?.blockControls?.commands?.toggleBlockMenu({ closeMenu: true }),
				);
			}}
		>
			{formatMessage(action.label)}
		</ToolbarDropdownItem>
	);
};
